import {inject, Injectable} from '@angular/core';
import {CmsApiService} from "./cms-api.service";
import {MetaField} from "./definitions/meta-field";
import {OptionInfo} from "./definitions/option-info";

@Injectable({
  providedIn: 'root'
})
export class ValueOptionService {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);

  private allValueOptionInformation: {[id: string]: OptionInfo};

  setAllValueOptions() {
    this.cms.getValueOptions().then(allValueOptionInformation => {
      this.allValueOptionInformation = allValueOptionInformation;
    })
  }

  getValueOptionsForField(field: MetaField): OptionInfo {
    let res: OptionInfo;
    if (field.option_info) {
      res = field.option_info
    } else if (field.value_option_id) {
      if (!this.allValueOptionInformation) {
        this.setAllValueOptions();
        res = null;
      } else {
        res = this.allValueOptionInformation[field.value_option_id];
      }
    }
    return res;
  }
}
